import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-event-pager',
  templateUrl: './event-pager.component.html',
  styleUrls: ['./event-pager.component.scss']
})
export class EventPagerComponent implements OnInit {

  @Input() public totalRecordsCount = 10;
  @Input() public currentPage = 1;
  @Output() public nextClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() public previousClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() public firstClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() public lastClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() public currentPageChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  /*  fire the next event and increase page number count if the page number is valid */
  selectNextPage(event) {
    this.cancelEvent(event);
    if (this.isValidPageNumber(this.currentPage + 1)) {
      this.currentPage = this.currentPage + 1;
      this.nextClick.emit(this.currentPage);
      this.currentPageChange.emit(this.currentPage);
    }
  }
  /* fire the previous event and decrease page number count if the page number is valid */
  selectPreviousPage(event) {
    this.cancelEvent(event);
    if (this.isValidPageNumber(this.currentPage - 1)) {
      this.currentPage = this.currentPage - 1;
      this.previousClick.emit(this.currentPage);
      this.currentPageChange.emit(this.currentPage);
    }
  }
  /*fire first page event and set the first page value */
  selectFirstPage(event) {
    this.cancelEvent(event);
    this.currentPage = 1;
    this.firstClick.emit(this.currentPage);
    this.currentPageChange.emit(this.currentPage);
  }

  /*fire last page event and set the lat page count */
  selectLastPage(event) {
    this.cancelEvent(event);
    this.currentPage = this.totalRecordsCount;
    this.lastClick.emit(this.currentPage);
    this.currentPageChange.emit(this.currentPage);
  }

  cancelEvent(event) {
    event.preventDefault();
  }

  isValidPageNumber(page: number): boolean {
    return page > 0 && page <= this.totalRecordsCount;
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/event-pager/event-pager.component.ts